import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { ICustomerMiningAccount } from '@entities/customer/ICustomerMiningAccount';
import { ISort } from '@entities/util/ISort';
import { IHostingClient } from '@entities/hosting/IHostingClient';

export interface IHostingClientsList {
  items: IHostingClient[];
  total_pages: number;
  total_items: number;
  current_page: number;
}

export const fetch = async (filters: {
  page?: number;
  search?: string;
  sort?: ISort | null;
  clientId?: string;
}): Promise<IHostingClientsList> => {
  let data = {};

  if (filters.sort) {
    data = {
      ...data,
      sort_order: filters.sort.type,
      sort_by: filters.sort.column,
    };
  }

  // const response = await api.get<IHostingClientsList>(
  //     `${BI_BASE_URL}/clients/${filters.clientId}/mining_accounts`,
  //     {
  //         params: {
  //             page: filters.page,
  //             ...data,
  //         },
  //     },
  // );

  // return response.data ?? [];

  return {
    items: [
      {
        id: 1,
        name: 'Geprgy Devidson',
        nickname: '123245gortje',
        nominal_power: 17,
        actual_power: 17,
        count_equipment: 21,
        tariff: 18,
      },
      {
        id: 2,
        name: 'Geprgy Devidson',
        nickname: '123245gortje',
        nominal_power: 17,
        actual_power: 17,
        count_equipment: 21,
        tariff: 18,
      },
      {
        id: 3,
        name: 'Geprgy Devidson',
        nickname: '123245gortje',
        nominal_power: 17,
        actual_power: 17,
        count_equipment: 21,
        tariff: 18,
      },
      {
        id: 4,
        name: 'Geprgy Devidson',
        nickname: '123245gortje',
        nominal_power: 17,
        actual_power: 17,
        count_equipment: 21,
        tariff: 18,
      },
      {
        id: 5,
        name: 'Geprgy Devidson',
        nickname: '123245gortje',
        nominal_power: 17,
        actual_power: 17,
        count_equipment: 21,
        tariff: 18,
      },
    ],
    total_pages: 1,
    total_items: 5,
    current_page: 1,
  };
};

export const useHostingClientList = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
